module.exports = __webpack_public_path__ + "static/media/instagram_icon.84d19496.svg";